import React from 'react'

import { Avatar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { shape, string } from 'prop-types'

import authorAvatar from 'images/home/ChrisCGmatum.webp'

const defaultAuthor = {
  name: 'ChrisCGmatum',
  href: 'https://www.cgtrader.com/designers/chriscgmatum',
  avatarUrl: authorAvatar,
}

const imageProps = { loading: 'lazy', decoding: 'async' }

function HeroAuthor({ createdByText, author = null }) {
  const authorData = author?.name ? author : defaultAuthor

  return (
    <a href={authorData.href} className="home-hero__author-badge">
      <span className="home-hero__author-text">{createdByText}</span>
      <Avatar img={author.avatarUrl} username={authorData.name} size="24" type="color" imageProps={imageProps} />
      <span className="home-hero__author-name">{authorData.name}</span>
    </a>
  )
}

HeroAuthor.propTypes = {
  createdByText: string.isRequired,
  author: shape({
    name: string,
    href: string,
    avatarUrl: string,
  }),
}

export default HeroAuthor
